import ContactForm from './contact-form';

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact-form/index.js